// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"error_Wrapper__byXPO","Container":"error_Container__8e2na","Links":"error_Links__A2ZbD","RawError":"error_RawError__3JaP1"};